<template>
	<div>
		<div v-html="dataInfo.content"></div>
	</div>
</template>

<script>
	import {
		GetAgreement
	} from '../api/api.js'
	export default {
		name: 'policy',
		data() {
			return {
				dataInfo: {}
			}
		},
		created() {
			this.getAgreement()
		},
		methods: {
			getAgreement() {
				let data = {
					configKey:'sys.agreement.pp',
					// token
				}
				GetAgreement(data).then(res => {
					// console.log('***/0617***')
					this.dataInfo = res.data
				})
			}
		}
	}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/view/policy.vue